import { render } from "./DragVertical.vue?vue&type=template&id=7eb03346"
import script from "./DragVertical.vue?vue&type=script&lang=js"
export * from "./DragVertical.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/DragVertical.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7eb03346"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7eb03346', __exports__)) {
    api.reload('7eb03346', __exports__)
  }
  
  module.hot.accept("./DragVertical.vue?vue&type=template&id=7eb03346", () => {
    api.rerender('7eb03346', render)
  })

}


export default __exports__